import { DebouncedTextInput } from "ra-friendsofbabba";
import React from "react";
import { SimpleForm } from "react-admin";
import { UniversityInput } from "../component/input";

const Form = ({ classes, ...props }) => (
  <SimpleForm {...props}>
    <UniversityInput source="university_id" fullWidth />
    <DebouncedTextInput source="name" maxLength={100} multiline fullWidth />
  </SimpleForm>
);
export default Form;
